<template>
<div>
  <div class="pa-md">
    <!-- Task is loaded -->
    <div v-if="!loading">
      <p class="has-text-centered has-text-weight-bold mb-lg is-size-5">Getting Started with EDI</p>
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">
            <transition name="fade" mode="out-in">
              <component :is="step"
                :connection="connection"
                :task="task"
                :ediAccount="ediAccount"
                :loading="loading"
                @edi:created="loadEdiAccounts(true)"
                @navigate="navigate"
              ></component>
            </transition>
            <!-- Cancel Task Option -->
            <div>
              <p class="has-text-grey-light has-text-centered is-size-7">
                This onboarding task was added based on your preferences. <br/>
                If you no longer need this task, you can remove it
                by <a href="#" @click.prevent="showDeleteTaskModal = true" class="has-text-info">clicking here.</a>
              </p>
            </div>
          </div>
          <!-- Return Link -->
          <div class="has-text-centered">
            <router-link :to="{ name: 'onboarding.tasks', params: { connection: this.$route.params.connection }}" class="is-size-7">
              Back to Tasks
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading Skeleton -->
    <div v-else>
      <div class="mb-md">
        <div class="columns is-centered">
          <div class="column is-one-quarter">
            <b-skeleton />
          </div>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">
            <loading message="Loading..." />
          </div>
          <!-- Return Link -->
          <div class="has-text-centered">
            <router-link :to="{ name: 'onboarding.tasks', params: { connection: this.$route.params.connection }}" class="is-size-7">
              Back to Tasks
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Task Modal -->
  <b-modal
    v-if="!loading && task !== null"
    :has-modal-card="true"
    :active.sync="showDeleteTaskModal"
    :can-cancel="['x', 'esc']">
    <RemoveTaskModal :taskId="task.id" @task:removed="returnToTasks" />
  </b-modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import RemoveTaskModal from '@/components/Models/Task/Modals/RemoveTaskModal'
import Intro from '../components/EdiAccount/Intro'
import Provision from '../components/EdiAccount/Provision'
import Account from '../components/EdiAccount/Account'

export default {
  components: {
    Intro,
    Provision,
    Account,
    RemoveTaskModal
  },
  computed: {
    ...mapGetters(['app', 'context']),
    loading () {
      return (this.loadingEdiAccounts || this.loadingTask)
    }
  },
  data () {
    return {
      loadingEdiAccounts: true,
      loadingTask: true,
      task: null,
      ediAccount: null,
      step: 'Intro',
      showDeleteTaskModal: false
    }
  },
  methods: {
    loadTask () {
      this.loadingTask = true
      const endpoint = this.context.route + '/assigned-tasks/' + this.$route.params.task + '/'
      this.$http.get(endpoint).then(response => {
        this.task = response.data
        this.loadingTask = false
      })
    },
    loadEdiAccounts (silent = false) {
      if (!silent) this.loadingEdiAccounts = true
      this.$http.get(this.context.route + '/edi-accounts/').then(response => {
        if (response.data.results.length > 0) {
          this.ediAccount = response.data.results[0]
          this.$http.get(this.context.route + '/ftp-accounts/').then(response => {
            if (response.data.results.length > 0) {
              this.$set(this.ediAccount, 'ftp_account', response.data.results[0])
            }
            this.loadingEdiAccounts = false
          })
        } else {
          this.loadingEdiAccounts = false
        }
      })
    },
    returnToTasks () {
      this.$buefy.toast.open({ type: 'is-info', message: 'Task removed.' })
      this.$router.push({ name: 'onboarding.tasks', params: { connection: this.$route.params.connection } })
    },
    navigate (step) {
      this.step = step
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.loadTask()
    this.loadEdiAccounts()
  },
  props: ['connection']
}
</script>
